import React, { useState } from 'react'

const Readyrekaran = () => {
  // Rate mapping for each type
  const rateMapping = {
    'gavthan': 1500,
    'jirayat': 1000,
    'binsheti': 800,
    'highway': 2000,
    'audhyogik': 2500
  };

  // State for form fields
  const [formData, setFormData] = useState({
    rekaranType: '',
    rate: ''
  });

  // State for storing all rekaran types in table
  const [rekaranList, setRekaranList] = useState([]);

  // State for edit mode
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  // Handle rekaran type change
  const handleTypeChange = (e) => {
    const selectedType = e.target.value;
    const rate = rateMapping[selectedType] || '';
    
    setFormData({
      rekaranType: selectedType,
      rate: rate
    });
  };

  // Handle rate change (if needed to override)
  const handleRateChange = (e) => {
    setFormData(prev => ({
      ...prev,
      rate: e.target.value
    }));
  };

  // Get Marathi display name
  const getDisplayName = (value) => {
    const typeNames = {
      'gavthan': 'गावठाण',
      'jirayat': 'जिरायत शेती जमीन',
      'binsheti': 'बिनशेती जमीन/भुकंड',
      'highway': 'हायवे वरील जमीन',
      'audhyogik': 'औद्योगिक बिन शेती जमीन'
    };
    return typeNames[value] || value;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.rekaranType) {
      alert('कृपया रेकनर प्रकार निवडा!');
      return;
    }

    if (isEditing) {
      // Update existing entry
      const updatedList = [...rekaranList];
      updatedList[editIndex] = { ...formData };
      setRekaranList(updatedList);
      setIsEditing(false);
      setEditIndex(null);
      alert('रेकनर प्रकार अपडेट करण्यात आला!');
    } else {
      // Add new entry
      setRekaranList([...rekaranList, { ...formData }]);
      alert('रेकनर प्रकार जोडला गेला!');
    }
    
    // Reset form
    setFormData({
      rekaranType: '',
      rate: ''
    });
  };

  // Handle form reset
  const handleReset = () => {
    setFormData({
      rekaranType: '',
      rate: ''
    });
    setIsEditing(false);
    setEditIndex(null);
  };

  // Handle Edit
  const handleEdit = (index) => {
    setFormData({ ...rekaranList[index] });
    setIsEditing(true);
    setEditIndex(index);
  };

  // Handle Delete
  const handleDelete = (index) => {
    if (window.confirm('तुम्हाला हा रेकनर प्रकार डिलीट करायचा आहे का?')) {
      const updatedList = rekaranList.filter((_, i) => i !== index);
      setRekaranList(updatedList);
      alert('रेकनर प्रकार डिलीट करण्यात आला!');
    }
  };

  // Clear all records
  const handleClearAll = () => {
    if (window.confirm('तुम्हाला सर्व रेकनर प्रकार डिलीट करायचे आहेत का?')) {
      setRekaranList([]);
      alert('सर्व रेकनर प्रकार डिलीट करण्यात आले!');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 p-4 md:p-8">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-20 -left-20 w-96 h-96 bg-gradient-to-r from-green-200 to-emerald-200 rounded-full mix-blend-multiply opacity-20 animate-float"></div>
        <div className="absolute top-1/2 -right-20 w-96 h-96 bg-gradient-to-r from-teal-200 to-cyan-200 rounded-full mix-blend-multiply opacity-20 animate-float animation-delay-2000"></div>
      </div>

      {/* Main Container */}
      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-12 text-center">
          <div className="inline-flex items-center justify-center p-3 bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl shadow-2xl mb-6 transform hover:scale-105 transition-transform duration-300">
            <div className="p-4 bg-white/20 backdrop-blur-sm rounded-xl">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent mb-4">
            रेडी रेकनर प्रकार/विभाग
          </h1>
          <div className="inline-block px-6 py-2 bg-gradient-to-r from-green-100 to-emerald-100 rounded-full border border-green-200">
            <p className="text-lg font-medium text-green-700">रेकनर प्रकार निवडा आणि दर सेट करा</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Side - Form */}
          <div className="relative">
            <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-48 h-2 bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 rounded-t-full blur-sm"></div>
            
            <div className="backdrop-blur-xl bg-white/95 rounded-3xl shadow-2xl border border-white/40 overflow-hidden h-fit">
              {/* Form Content */}
              <form onSubmit={handleSubmit} className="p-8 space-y-8">
                <div className="mb-6">
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                    {isEditing ? 'रेकनर प्रकार संपादित करा' : 'नवीन रेकनर प्रकार जोडा'}
                  </h2>
                  <p className="text-sm text-gray-600">
                    {isEditing ? 'रेकनर प्रकारची माहिती संपादित करा' : 'नवीन रेकनर प्रकार निवडा'}
                  </p>
                </div>

                <div className="space-y-6">
                  {/* Rekaran Type Dropdown */}
                  <div className="space-y-3">
                    <label className="block text-lg font-semibold text-gray-700">
                      रेडी रेकनर प्रकार/विभाग
                    </label>
                    <select
                      value={formData.rekaranType}
                      onChange={handleTypeChange}
                      className="w-full p-4 border-2 border-green-200 rounded-xl focus:border-green-500 focus:ring-4 focus:ring-green-100 focus:outline-none transition-all duration-300 text-lg appearance-none bg-white"
                      required
                    >
                      <option value="">रेकनर प्रकार निवडा</option>
                      <option value="gavthan">गावठाण</option>
                      <option value="jirayat">जिरायत शेती जमीन</option>
                      <option value="binsheti">बिनशेती जमीन/भुकंड</option>
                      <option value="highway">हायवे वरील जमीन</option>
                      <option value="audhyogik">औद्योगिक बिन शेती जमीन</option>
                    </select>
                  </div>

                  {/* Rate Field */}
                  <div className="space-y-3">
                    <label className="block text-lg font-semibold text-gray-700">
                      दर (रु. प्रति युनिट)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        value={formData.rate}
                        onChange={handleRateChange}
                        placeholder="दर टाइप करा"
                        className="w-full p-4 border-2 border-green-200 rounded-xl focus:border-green-500 focus:ring-4 focus:ring-green-100 focus:outline-none transition-all duration-300 text-lg pl-12"
                        required
                      />
                      <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                        <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center">
                          <span className="text-white font-bold">₹</span>
                        </div>
                      </div>
                    </div>
                    <p className="text-sm text-gray-500 mt-1">
                      {formData.rekaranType ? 
                        `${getDisplayName(formData.rekaranType)} साठी सुझावित दर: ₹${rateMapping[formData.rekaranType]}` 
                        : 'प्रकार निवडल्यानंतर सुझावित दर दिसेल'}
                    </p>
                  </div>

                 
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row justify-center gap-6 pt-8">
                  <button
                    type="submit"
                    className="group relative px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold rounded-2xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-green-300 flex-1"
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-green-600 to-emerald-700 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="relative flex items-center justify-center space-x-3">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:animate-bounce" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-lg">{isEditing ? 'अपडेट करा' : 'सेव्ह करा'}</span>
                    </div>
                  </button>
                  
                  <button
                    type="button"
                    onClick={handleReset}
                    className="group relative px-8 py-4 bg-gradient-to-r from-gray-500 to-gray-600 text-white font-bold rounded-2xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-gray-300 flex-1"
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-700 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="relative flex items-center justify-center space-x-3">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:rotate-180 transition-transform duration-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                      </svg>
                      <span className="text-lg">{isEditing ? 'रद्द करा' : 'रिसेट करा'}</span>
                    </div>
                  </button>
                </div>
              </form>

              {/* Footer */}
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200/50 py-4 px-8">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className={`w-3 h-3 rounded-full ${isEditing ? 'bg-yellow-400' : 'bg-green-400'} animate-pulse`}></div>
                    <span className="text-sm font-medium text-gray-600">
                      {isEditing ? 'संपादन मोड' : 'तयार'}
                    </span>
                  </div>
                  <span className="text-sm text-gray-500">
                    एकूण प्रकार: {rekaranList.length}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Table */}
          <div className="relative">
            <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-48 h-2 bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 rounded-t-full blur-sm"></div>
            
            <div className="backdrop-blur-xl bg-white/95 rounded-3xl shadow-2xl border border-white/40 overflow-hidden h-fit">
              {/* Table Header */}
              <div className="p-6 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-blue-100">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                      रेकनर प्रकार यादी
                    </h2>
                    <p className="text-sm text-gray-600">सर्व रेकनर प्रकारची यादी</p>
                  </div>
                  <div className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-xl">
                    <span className="font-bold text-lg">{rekaranList.length}</span>
                  </div>
                </div>
              </div>

              {/* Table Content */}
              <div className="p-6">
                {rekaranList.length === 0 ? (
                  <div className="text-center py-12">
                    <div className="inline-flex p-4 bg-gradient-to-r from-gray-100 to-gray-200 rounded-2xl mb-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-600 mb-2">अद्याप कोणतेही रेकनर प्रकार नाही</h3>
                    <p className="text-gray-500">रेकनर प्रकार जोडण्यासाठी डाव्या बाजूला फॉर्म भरा</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gradient-to-r from-green-50 to-emerald-50">
                          <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700 border-b border-green-100">क्र.</th>
                          <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700 border-b border-green-100">रेकनर प्रकार</th>
                          <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700 border-b border-green-100">दर (₹)</th>
                          <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700 border-b border-green-100">क्रिया</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rekaranList.map((item, index) => (
                          <tr 
                            key={index} 
                            className={`hover:bg-gradient-to-r hover:from-green-50/50 hover:to-emerald-50/50 transition-colors duration-200 ${
                              index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                            }`}
                          >
                            <td className="py-3 px-4 border-b border-gray-100">
                              <div className="flex items-center">
                                <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg font-bold">
                                  {index + 1}
                                </div>
                              </div>
                            </td>
                            <td className="py-3 px-4 border-b border-gray-100">
                              <div className="font-medium text-gray-800">
                                {getDisplayName(item.rekaranType)}
                              </div>
                              <div className="text-sm text-gray-500">
                                {item.rekaranType}
                              </div>
                            </td>
                            <td className="py-3 px-4 border-b border-gray-100">
                              <div className="flex items-center space-x-2">
                                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-yellow-100 to-yellow-200 rounded-lg">
                                  <span className="text-lg font-bold text-yellow-700">₹</span>
                                </div>
                                <div>
                                  <div className="text-xl font-bold text-gray-800">
                                    {item.rate}
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    प्रति युनिट
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="py-3 px-4 border-b border-gray-100">
                              <div className="flex items-center space-x-2">
                                <button
                                  onClick={() => handleEdit(index)}
                                  className="group relative p-2 bg-gradient-to-r from-blue-100 to-blue-200 hover:from-blue-200 hover:to-blue-300 rounded-lg transition-all duration-300"
                                  title="संपादित करा"
                                >
                                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 relative" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                  </svg>
                                </button>
                                <button
                                  onClick={() => handleDelete(index)}
                                  className="group relative p-2 bg-gradient-to-r from-red-100 to-red-200 hover:from-red-200 hover:to-red-300 rounded-lg transition-all duration-300"
                                  title="डिलीट करा"
                                >
                                  <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-red-600 rounded-lg blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-600 relative" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {/* Table Footer */}
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200/50 py-4 px-8">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <span className="text-sm text-gray-500">
                      {rekaranList.length === 0 ? 'कोणतेही डेटा नाही' : `एकूण ${rekaranList.length} प्रकार`}
                    </span>
                    {rekaranList.length > 0 && (
                      <div className="flex items-center space-x-2 px-3 py-1 bg-gradient-to-r from-green-100 to-emerald-100 rounded-lg">
                        <span className="text-sm text-gray-600">एकूण दर:</span>
                        <span className="font-bold text-green-700">
                          ₹{rekaranList.reduce((sum, item) => sum + parseInt(item.rate || 0), 0)}
                        </span>
                      </div>
                    )}
                  </div>
                  {rekaranList.length > 0 && (
                    <button
                      onClick={handleClearAll}
                      className="px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white text-sm font-medium rounded-lg transition-all duration-300"
                    >
                      सर्व क्लियर करा
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add custom animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          33% {
            transform: translateY(-20px) rotate(120deg);
          }
          66% {
            transform: translateY(20px) rotate(240deg);
          }
        }
        
        .animate-float {
          animation: float 20s infinite ease-in-out;
        }
        
        .animation-delay-2000 {
          animation-delay: 7s;
        }
        
        select {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2310b981'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
          background-position: right 1rem center;
          background-repeat: no-repeat;
          background-size: 1.5em 1.5em;
          padding-right: 2.5rem;
        }
      `}</style>
    </div>
  )
}

export default Readyrekaran